<template>
  <div class="personal-author">
    <div class="bd" :class="info.user_type !== 1 ? 'normal-user' : ''">
      <div class="userface">
        <img :src="info.avatar" alt>
      </div>
      <div class="username">
        {{ info.nickname }}
      </div>
      <div class="medal">
        <i class="icon-uup" :class="classes" />
      </div>
      <div class="info">
        <dl>
          <dt>浏览数</dt>
          <dd>{{ parseViewNumber(info.works_scan_cnt) }}</dd>
        </dl>
        <i class="gap" />
        <dl>
          <dt>收藏数</dt>
          <dd>{{ parseViewNumber(info.works_like_cnt) }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
const NUMBER_1W = 10000
const NUMBER_1 = 1
const NUMBER_0 = 0

export default {
  name: 'PersonalAuthor',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    classes () {
      return this.info.is_enterprise ? 'is-enterprise' : `type-${this.info.user_type}`
    }
  },
  data() {
    return {}
  },
  methods: {
    parseViewNumber(num) {
      if (isNaN(num)) {
        return NUMBER_0
      }

      if (num < NUMBER_1W) {
        return num
      }

      return `${(num / NUMBER_1W).toFixed(NUMBER_1)}万`
    },
  },
}
</script>

<style scoped lang="scss">
.personal-author {
  padding: 20px 18px 0;
  .bd {
    position: relative;
    height: 112px;
    padding-top: 58px;
    text-align: center;
    background: #f7f8f8;
    &.normal-user {
      height: 82px;
    }
  }
  .userface {
    position: absolute;
    left: 50%;
    top: -10px;
    width: 64px;
    height: 64px;
    margin-left: -32px;
    background: #999;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .username {
    margin-bottom: 2px;
    font-size: 20px;
    color: #333;
  }
  .medal {
    margin-bottom: 7px;
  }
  .info {
    font-size: 12px;
    dl {
      display: inline-block;
      vertical-align: middle;
    }
    .gap {
      display: inline-block;
      vertical-align: middle;
      width: 1px;
      height: 31px;
      margin: 0 20px;
      background: #d9d9d9;
    }
    dt {
      margin-bottom: 5px;
      color: #727c8e;
    }
    dd {
      color: #222;
    }
  }
  .icon-uup {
    vertical-align: middle;
    height: 26px;
  }
  .is-enterprise {
    display: inline-block;
    width: 93px;
    background: url('~@/assets/images/badge_enterprise_v2.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .type-1{
    display: inline-block;
    width: 86px;
    background: url('~@/assets/images/uup.png') 0 0 no-repeat;
  }
}
</style>
